import { memo, useMemo } from 'react'
import FlightDeals from './FlightDeals'
import useFlightDeals from 'hooks/Flights/useFlightDeals'

function HomepageFlightDeals() {
  const [flightDeals, flightDealsLoading] = useFlightDeals()

  const heroDeals = useMemo(() => flightDeals.filter(deal => !!deal.heroImage?.id), [flightDeals])

  if (!flightDealsLoading && heroDeals.length === 0) {
    return null
  }

  return (
    <FlightDeals flightDeals={flightDeals} flightDealsLoading={flightDealsLoading} />
  )
}

export default memo(HomepageFlightDeals)
